<script setup lang="ts">
import { useRouter } from "vue-router";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import Navbar from "./../home/repeat/Navbar.vue";
import { ref } from "vue";
const router = useRouter();
</script>

<template>
  <div class="efficient">
    <div class="main">
      <div class="kong">
        <Header> </Header>
      </div>
      <div class="img_box">
        <div class="img_text">
          <div class="img_inner">
            <h2>{{ $t("system.about.efficient.inner_h") }}</h2>
            <div class="img_main">
              <div>{{ $t("system.about.efficient.main_d") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="wrap_title">
          <div class="title_box">
            <div class="title">
              <a class="no" href="/">{{ $t("system.home.menu.home") }}</a>
              <text>></text>
              <a class="th">{{ $t("system.home.menu.efficient") }}</a>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="con_box">
            <div class="con_box_t">
              <div class="con_img">
                <img src="./../../../public/963.jpg" alt="" />
              </div>
              <div class="con_text">
                {{ $t("system.about.efficient.text") }}
              </div>
            </div>
            <div class="con_box_b">
              <div class="box_inner">
                <div style="height: auto">
                  {{ $t("system.about.efficient.inner_t") }}
                </div>
                <div style="height: auto">
                  {{ $t("system.about.efficient.inner_b") }}
                </div>
                <p style="height: 30px; margin: 0"></p>
              </div>
            </div>
          </div>
          <div class="con_wrap">
            <div class="wrap_inner">
              <div class="wrap_left">
                <div class="wrap_l_text">
                {{ $t('system.about.efficient.wrap_text') }}
                </div>
              </div>
              <div class="wrap_right">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"> </Navbar>
  </div>
</template>
<style lang="scss" scoped>
.main {
  width: 100%;
  height: auto;
  overflow: hidden;
  box-sizing: border-box;
}
.kong {
  max-width: 1200px;
  height: 120px;
}
.img_box {
  width: 100%;
  height: 553px;
  position: relative;
  background-image: url("./../../../public/1212.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100% 100%;
}
.img_text {
  width: 1519px;
  height: 173px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
  line-height: 1.25;
}
.img_inner {
  align-items: center;
  width: 1230px;
  padding: 0 15px;
  height: 173px;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}
.img_main {
  align-items: center;
  width: 100%;
  height: 103px;
  font-size: 32px;
  line-height: 1.72;
  margin-top: 20px;
}
h2 {
  width: 100%;
  font-size: 46px;
  height: 50px;
  padding: 0;
  font-weight: bold;
  color: #20538c;
  margin: 0;
}
.wrap {
  width: 100%;
  height: auto;
}
.wrap_title {
  padding: 30px 0;
  width: 100%;
  color: #3e3a39;
  background-color: #fff;
  font-size: 14px;
  height: 86px;
}
.title_box {
  width: 100%;
  max-width: 1230px;
  padding: 0 15px;
  margin: 0 auto;
}
.title {
  width: 100%;
  height: 100%;
  font-size: 18px;
  margin: 0 -8px;
}
.title a {
  display: inline-block;
  padding: 0 8px;
  font-weight: bold;
  color: #696b71;
}
.content {
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 20px;
}
.con_box {
  width: 1230px;
  padding: 0 15px;
  margin: 0 auto;
  height: 703px;
}
.con_box_t {
  width: 100%;
  height: 320px;
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
}
.con_img {
  width: 50%;
  height: 100%;
  margin-right: 3px;
}
.con_text {
  font-size: 24px;
  flex: 1 0 0;
  overflow: hidden;
  background: #f0f0f0;
  padding: 50px;
  line-height: 1.5;
  display: flex;
  align-items: center;
  font-weight: bold;
}
.con_box_b {
  width: 1200px;
  height: 380px;
  font-size: 16px;
  display: flex;
  align-items: center;
  min-height: 380px;
  background: 50% 0 no-repeat;
  background-size: cover;
  margin-top: 3px;
  background-image: url("./../../../public/76.jpg");
}
.box_inner {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  justify-content: space-between;
  width: 50%;
  height: 314px;
  line-height: 1.875;
  padding: 50px;
}
.con_wrap {
  width: 100%;
  height: 550px;
  background-color: #696b71;
  color: #fdfdfd;
  margin-top: 3px;
  padding-top: 50px;
  padding-bottom: 50px;
  background-attachment: local;
}
.con_wrap .wrap_inner {
  display: flex;
  align-items: center;
  min-height: 450px;
}
.wrap_inner {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}
.wrap_left {
  width: 50%;
  padding: 0 50px;
}
.wrap_l_text {
  font-size: 16px;
  line-height: 1.875;
}

.wrap_right {
  width: 50%;
  height:100%;
  text-align: center;
  background-image: url('./../../../public/6b007a2a2f036da24c41ea983a95f2c.png');
  background-size: cover;
 background-position: 50%;
  z-index: 3;
}
* {
  box-sizing: border-box;
}
</style>
